import React, { useState } from 'react';
import LogoSimpleBlack from './mobilelogoblack.png';
import './Login.css';
import LoginLoader from '../Loader/LoginLoader';

function Login({ notice, onForgotPassword, onToggle }) {
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const enviarDatos = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    const datos = {
      correo,
      contraseña: contrasena,
    };

    try {
      setLoading(true);

      const response = await fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datos),
        credentials: 'include',
      });

      if (response.ok) {
        window.location.href = '/';
        return;
      }

      if (response.status === 401) {
        const data = await response.json().catch(() => ({}));
        setErrorMessage(data.error || 'Los datos ingresados son incorrectos.');
        return;
      }

      setErrorMessage('No pudimos iniciar sesión. Probá nuevamente.');
    } catch (error) {
      console.error('Error en enviarDatos:', error);
      setErrorMessage('No pudimos conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-panel">
      <img className="auth-logo" src={LogoSimpleBlack} alt="Cannubis" />
      <div className="auth-heading">
        <p className="auth-kicker">Acceso Cannubis</p>
        <h1>Ingresá a tu cuenta</h1>
      </div>

      {notice && <p className={`auth-message ${notice.type}`}>{notice.text}</p>}

      {loading ? (
        <LoginLoader />
      ) : (
        <form className="auth-form" onSubmit={enviarDatos}>
          <div className="form-group">
            <label htmlFor="correo">Correo electrónico</label>
            <input
              autoComplete="email"
              id="correo"
              name="correo"
              onChange={(e) => setCorreo(e.target.value)}
              required
              type="email"
              value={correo}
            />
          </div>
          <div className="form-group">
            <label htmlFor="contrasena">Contraseña</label>
            <input
              autoComplete="current-password"
              id="contrasena"
              name="contrasena"
              onChange={(e) => setContrasena(e.target.value)}
              required
              type="password"
              value={contrasena}
            />
          </div>

          {errorMessage && <p className="auth-message error">{errorMessage}</p>}

          <button className="auth-submit" type="submit">Iniciar sesión</button>
        </form>
      )}

      {!loading && (
        <div className="auth-links">
          <button type="button" onClick={onForgotPassword}>Olvidé mi contraseña</button>
          <button type="button" onClick={onToggle}>Crear cuenta</button>
        </div>
      )}
    </div>
  );
}

export default Login;
